// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-modal .modal__container{padding-top:0;padding-bottom:0}@media(max-width:767.98px){.register-modal .modal__container{padding-top:0;padding-bottom:0}}.register-modal .modal__body{padding-top:20px!important}@media(max-width:767.98px){.register-modal .modal__body{padding-top:44px!important}}.register-modal .form-header__header{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
